export default __webpack_public_path__ + "static/media/iconJira.627b89f9.png";